import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import LoaderPlugin from './plugins/loaderPlugin'
import { FontAwesomeIcon } from './plugins/font-awesome'
import { initTheme } from './composables/useTheme'
import 'vue-multiselect/dist/vue-multiselect.css'
import './assets/css/main.css'

initTheme()

/* eslint-disable */
var app = createApp(App)
  .use(store)
  .use(router)
  .use(LoaderPlugin)
  .component('font-awesome-icon', FontAwesomeIcon)

app.mount('#app')

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Admin Dashboard'
  next()
})
